module.exports = __webpack_public_path__ + "static/media/easy_to_use.4a18d769.svg";